import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchStockTakeHistory} from "./actions";
import ListView from "../common/ListView";
import {Button} from "antd";
import DateTimeDisplay from "../common/DateTimeDisplay";
import {decodeParams} from "../utils/params";

class StockTakeHistoryPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    /* state */
    searchHistory: PropTypes.object.isRequired,
    /* actions */
    searchStockTakeHistory: PropTypes.func.isRequired,
  };

  render() {
    const {
      history, searchStockTakeHistory,
      searchHistory: {searching, pagination, filters, sorter, searchFilter, results},
      match: {params},
    } = this.props;
    const {stockTakeId} = decodeParams(params);
    const columns = [
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (dateTime) => <DateTimeDisplay dateTime={dateTime}/>,
        className: 'nowrap-column',
      },
      {
        title: 'Event',
        dataIndex: 'eventName',
        key: 'eventName',
        sorter: true,
        className: 'nowrap-column',
      },
      {
        title: 'Product',
        dataIndex: 'productDisplay',
        key: 'productId',
        sorter: true,
        className: 'nowrap-column',
      },
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
        className: 'nowrap-column',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
      },
    ];
    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          " History"
        ]}
        loading={searching}
        columns={columns}
        dataSourceProvider={(payload) => searchStockTakeHistory({...payload, filters: {...payload.filters, stockTakeId}})}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        rowKey="eventId"
        scroll={{x: 1200}}
      />
    );
  }
}

const mapStateToProps = state => ({
  searchHistory: state.stockTake.searchHistory,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchStockTakeHistory,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StockTakeHistoryPage);



// WEBPACK FOOTER //
// ./src/StockTake/StockTakeHistoryPage.js